import { render, staticRenderFns } from "./MultiLanguageInput.vue?vue&type=template&id=a14a8f4a&scoped=true&"
import script from "./MultiLanguageInput.vue?vue&type=script&lang=js&"
export * from "./MultiLanguageInput.vue?vue&type=script&lang=js&"
import style0 from "./MultiLanguageInput.vue?vue&type=style&index=0&id=a14a8f4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a14a8f4a",
  null
  
)

export default component.exports